import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function EnviarNotificacionPush() {
  const [notificacion, setNotificacion] = useState({
    title: '',
    message: '',
    sendTo: 'all' // 'all', 'estudiante', 'profesor'
  });
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!notificacion.title.trim() || !notificacion.message.trim()) {
      setMensaje({ tipo: 'error', texto: 'Por favor completa título y mensaje' });
      return;
    }

    setEnviando(true);
    setMensaje({ tipo: '', texto: '' });

    try {
      const token = localStorage.getItem('token');
      
      const payload = {
        title: notificacion.title,
        message: notificacion.message
      };

      // Si no es "all", agregar el rol específico
      if (notificacion.sendTo !== 'all') {
        payload.role = notificacion.sendTo;
      }

      const response = await axios.post(
        `${API}/notifications/send-push`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setMensaje({ 
        tipo: 'success', 
        texto: response.data.message || 'Notificación enviada exitosamente' 
      });
      
      // Limpiar formulario
      setNotificacion({
        title: '',
        message: '',
        sendTo: 'all'
      });

    } catch (error) {
      console.error('Error enviando notificación:', error);
      setMensaje({ 
        tipo: 'error', 
        texto: error.response?.data?.detail || 'Error al enviar la notificación' 
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 mb-4 md:mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
            📱 Enviar Notificación Push
          </h1>
          <p className="text-sm md:text-base text-gray-600">
            Envía notificaciones instantáneas a los usuarios suscritos
          </p>
        </div>

        {/* Formulario */}
        <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
          <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
            {/* Título */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Título de la notificación *
              </label>
              <input
                type="text"
                value={notificacion.title}
                onChange={(e) => setNotificacion({ ...notificacion, title: e.target.value })}
                placeholder="Ej: Cambio de horario"
                maxLength={50}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <p className="text-xs text-gray-500 mt-1">
                {notificacion.title.length}/50 caracteres
              </p>
            </div>

            {/* Mensaje */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mensaje *
              </label>
              <textarea
                value={notificacion.message}
                onChange={(e) => setNotificacion({ ...notificacion, message: e.target.value })}
                placeholder="Ej: La clase de mañana se realizará a las 19:00 en lugar de las 18:00"
                maxLength={200}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <p className="text-xs text-gray-500 mt-1">
                {notificacion.message.length}/200 caracteres
              </p>
            </div>

            {/* Destinatarios */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Enviar a
              </label>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="all"
                    checked={notificacion.sendTo === 'all'}
                    onChange={(e) => setNotificacion({ ...notificacion, sendTo: e.target.value })}
                    className="mr-2"
                  />
                  <span className="text-gray-700">👥 Todos los usuarios suscritos</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="estudiante"
                    checked={notificacion.sendTo === 'estudiante'}
                    onChange={(e) => setNotificacion({ ...notificacion, sendTo: e.target.value })}
                    className="mr-2"
                  />
                  <span className="text-gray-700">🎓 Solo estudiantes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="profesor"
                    checked={notificacion.sendTo === 'profesor'}
                    onChange={(e) => setNotificacion({ ...notificacion, sendTo: e.target.value })}
                    className="mr-2"
                  />
                  <span className="text-gray-700">👨‍🏫 Solo profesores</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="pastor"
                    checked={notificacion.sendTo === 'pastor'}
                    onChange={(e) => setNotificacion({ ...notificacion, sendTo: e.target.value })}
                    className="mr-2"
                  />
                  <span className="text-gray-700">⛪ Solo pastores</span>
                </label>
              </div>
            </div>

            {/* Vista previa */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <p className="text-xs font-medium text-gray-500 mb-2">VISTA PREVIA</p>
              <div className="bg-white rounded-lg shadow-md p-3 max-w-sm">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-blue-500 rounded-lg p-2 mr-3">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-900 text-sm">
                      {notificacion.title || 'Título de la notificación'}
                    </p>
                    <p className="text-gray-600 text-xs mt-1">
                      {notificacion.message || 'Mensaje de la notificación'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Mensaje de estado */}
            {mensaje.texto && (
              <div className={`p-4 rounded-lg ${
                mensaje.tipo === 'success' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
              }`}>
                <div className="flex items-center">
                  {mensaje.tipo === 'success' ? (
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  )}
                  <span>{mensaje.texto}</span>
                </div>
              </div>
            )}

            {/* Botón enviar - Ajustado para móvil */}
            <div className="sticky bottom-0 -mx-4 md:mx-0 -mb-4 md:mb-0 bg-white md:bg-transparent p-4 md:p-0 border-t md:border-t-0 border-gray-200">
              <button
                type="submit"
                disabled={enviando || !notificacion.title.trim() || !notificacion.message.trim()}
                className={`w-full py-3 px-4 md:px-6 rounded-lg font-medium text-sm md:text-base transition-colors ${
                  enviando || !notificacion.title.trim() || !notificacion.message.trim()
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
              >
                {enviando ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Enviando...
                  </span>
                ) : (
                  <>📱 Enviar Notificación</>
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Información adicional */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4 md:mt-6 mb-20 md:mb-0">
          <div className="flex">
            <svg className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">Información importante:</p>
              <ul className="list-disc list-inside space-y-1 text-xs">
                <li>Las notificaciones se envían solo a usuarios que hayan aceptado permisos</li>
                <li>Mantén los mensajes breves y claros</li>
                <li>Usa esta función para comunicaciones urgentes o importantes</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
